export const isInRange = (value: number, min: number, max: number) => value >= min && value <= max
